import type { NumberingPattern } from '@/helpers/seatEditor/editor'

export type Tool = 'select' | 'add' | 'erase' | 'type' | 'number' | 'gap' | 'move'

export interface ToolDef {
  key: Tool
  name: string
  icon: string
  /** The key that picks the tool */
  shortcut: string
  tooltip: string
  /** Shown in the options bar when the tool has no options */
  hint: string
}

export const TOOLS: ToolDef[] = [
  {
    key: 'select',
    name: 'Selecionar',
    icon: 'fa-solid fa-arrow-pointer',
    shortcut: 'V',
    tooltip: 'Clique numa célula para abri-la no painel. Shift+clique: retângulo; Ctrl/⌘+clique: alterna; arraste: retângulo.',
    hint: 'Clique: seleciona · Shift+clique: retângulo · Ctrl/⌘+clique: alterna · arraste: retângulo · Del remove · Shift+←/→ move · Esc limpa',
  },
  {
    key: 'add',
    name: 'Adicionar',
    icon: 'fa-solid fa-plus',
    shortcut: 'A',
    tooltip: 'Pinte células vazias para criar cadeiras. Pintar a linha "nova" cria uma fila.',
    hint: 'Pinte células vazias: cada uma vira uma cadeira com o próximo número livre da fila. A linha "nova" cria uma fila, a última coluna alarga a seção.',
  },
  {
    key: 'erase',
    name: 'Apagar',
    icon: 'fa-solid fa-eraser',
    shortcut: 'E',
    tooltip: 'Pinte cadeiras para removê-las.',
    hint: 'Pinte cadeiras para removê-las. Ao soltar, o traço inteiro vira um passo do Desfazer.',
  },
  {
    key: 'type',
    name: 'Tipo',
    icon: 'fa-solid fa-wheelchair',
    shortcut: 'T',
    tooltip: 'Escolha um tipo na barra de opções (1–4) e pinte as cadeiras.',
    hint: '',
  },
  {
    key: 'number',
    name: 'Numerar',
    icon: 'fa-solid fa-arrow-down-1-9',
    shortcut: 'N',
    tooltip: 'Arraste por uma fila: as células do traço recebem nomes no padrão escolhido. Células vazias viram cadeiras.',
    hint: '',
  },
  {
    key: 'gap',
    name: 'Corredor',
    icon: 'fa-solid fa-arrows-left-right-to-line',
    shortcut: 'C',
    tooltip: 'Clique no número da coluna para abrir um corredor na seção inteira, ou numa célula só para aquela fila. Shift+clique fecha.',
    hint: 'Clique no número de uma coluna: corredor na seção inteira; numa célula: só naquela fila. Shift+clique fecha uma coluna vazia.',
  },
  {
    key: 'move',
    name: 'Mover',
    icon: 'fa-solid fa-up-down-left-right',
    shortcut: 'M',
    tooltip: 'Arraste uma cadeira para outra coluna da mesma fila. Com várias selecionadas, arraste uma delas para mover todas.',
    hint: 'Arraste uma cadeira para outra coluna da mesma fila (se ocupada, as duas trocam). Arrastar uma cadeira selecionada move a seleção inteira.',
  },
]

export const PATTERN_LABELS: Record<NumberingPattern, string> = {
  ascending: 'Crescente (1, 2, 3…)',
  descending: 'Decrescente (…3, 2, 1)',
  centre_odd_left: 'Do centro: ímpares à esquerda (…3, 1, 2, 4…)',
  centre_even_left: 'Do centro: pares à esquerda (…4, 2, 1, 3…)',
}

export const PATTERN_ITEMS = (Object.keys(PATTERN_LABELS) as NumberingPattern[]).map(value => ({ title: PATTERN_LABELS[value], value }))
